import '../App.css';
import NavBar from '../components/navbar';
import { useState } from 'react';
import { getCookie } from '../utils/csrf';

function Consult() {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [businessEmail, setBusinessEmail] = useState('');
    const [preferredContact, setPreferredContact] = useState('');
    const [availability, setAvailability] = useState('');
    const [businessDetails, setBusinessDetails] = useState('');
    const [businessChallenges, setBusinessChallenges] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const apiBaseUrl = process.env.REACT_APP_API_URL;

    async function submitcontent() {

        setName('')
        setEmail('')
        setBusinessChallenges('')
        setBusinessName('')
        setBusinessEmail('')
        setPreferredContact('')
        setAvailability('')
        setBusinessDetails('')
        setPhoneNumber('')



        await fetch(`${apiBaseUrl}/freeconsultant/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": getCookie('csrftoken')
            },
            body: JSON.stringify({
                name: name,
                email: email,
                businessname: businessName,
                businessemail: businessEmail,
                phonenumber: phoneNumber,
                preferredcontact: preferredContact,
                availability: availability,
                businessdetails: businessDetails,
                businesschallenges: businessChallenges,
            })
        })
    }


  return (
    <div className="homepage">
      <NavBar />
      <div className="contactuspage">
        <div className="contactmainsection">
          <div className="contactus consult">
            <div className="floating-placeholder">
              <input type="text" placeholder="Name..." onChange={(e) => setName(e.target.value)} required value={name}/>
              <span>Name...</span>
            </div>
            <div className="floating-placeholder">
              <input type="email" placeholder="Email..." onChange={(e) => setEmail(e.target.value)} required value={email}/>
              <span>Email...</span>
            </div>
            <div className="floating-placeholder">
              <input type="text" placeholder="Business name..." onChange={(e) => setBusinessName(e.target.value)} required value={businessName}/>
              <span>Business name...</span>
            </div>
            <div className="floating-placeholder">
              <input type="email" placeholder="Business email..." onChange={(e) => setBusinessEmail(e.target.value)} required value={businessEmail}/>
              <span>Business email...</span>
            </div>
            <div className="floating-placeholder">
              <input type="email" placeholder="Phone Number..." onChange={(e) => setPhoneNumber(e.target.value)} required value={phoneNumber}/>
              <span>Phone Number...</span>
            </div>
            <div className="floating-placeholder">
              <input type="text" placeholder="Preferred contact method..." onChange={(e) => setPreferredContact(e.target.value)} required value={preferredContact}/>
              <span>Preferred contact method...</span>
            </div>
            <div className="floating-placeholder">
              <input type="datetime-local" placeholder="Availability" onChange={(e) => setAvailability(e.target.value)} required value={availability}/>
              <span>Availability</span>
            </div>
            <div className="floating-placeholder long">
              <textarea placeholder="Tell us about your business..." onChange={(e) => setBusinessDetails(e.target.value)} required value={businessDetails}/>
              <span>Tell us about your business...</span>
            </div>
            <div className="floating-placeholder long">
              <textarea placeholder="Tell us about your challenges..." onChange={(e) => setBusinessChallenges(e.target.value)} required value={businessChallenges}/>
              <span>Tell us about your challenges...</span>
            </div>
            <div className="consultbutton" style={{ marginTop: '3%' }} onClick={submitcontent}>Submit</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Consult;
